/** Keys of the AI content tools (group "admin", "Công cụ nội dung"). */
export const AI_TOOLS = {
  genExercises: "gen_exercises",
  genReading: "gen_reading",
  genUnitTheory: "gen_unit_theory",
  genDistractors: "gen_distractors",
  contentReview: "content_review",
  translateText: "translate_text",
  feedbackSummary: "feedback_summary",
  notificationDraft: "notification_draft",
} as const;
